module.exports = __webpack_public_path__ + "img/loan_pendiente.4bf016a2.png";